export * from 'server/models/BerthCapabilityAssignment';


// WEBPACK FOOTER //
// ./data/models/BerthCapabilityAssignment.ts